///////////////////////////////////////////////////////////////
// NOTIFY DISPLAY WITH TIMER
///////////////////////////////////////////////////////////////
$(function () {
    for (var i = 1; i <= 10; i++) {
        dismiss(i);
    }

    function dismiss(cnt) {
        setTimeout(function () {
            $('.alert-auto-dismiss').each(function (_index, item) {
                var block = $(item);
                var allItems = block.find('li');
                var totamMessages = allItems.length;
                var dismissableItemsNow = allItems.filter('.auto-dismiss-' + cnt);
                var itemsLeftAfterDismissing = totamMessages - dismissableItemsNow.length;

                if (totamMessages === 0 || itemsLeftAfterDismissing === allItems || itemsLeftAfterDismissing === 0) {
                    block.slideUp('normal', function () {
                        $(this).remove();
                    });
                }

                dismissableItemsNow.each(function (_i, message) {
                    $(message).slideUp('normal', function () {
                        $(this).remove();
                    });
                });
            });
        }, cnt * 1000);
    }
});
